<template>
  <div class="mainBox">
    <div class="topNav">
      <van-nav-bar :fixed="true" :placeholder="true"
        :title="title"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      >
        <template #right>
          <van-icon name="add-o" v-if="showAdd" size="26" @click="toUpload" />
        </template>
      </van-nav-bar>
    </div>
    <!-- 下拉刷洗 -->
    <van-pull-refresh
      v-model="isRefreshLoading"
      success-text="刷新成功"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div
          class="projectItem"
          v-for="item in dataList"
        >
          <van-row gutter="20">
            <van-col span="6">
              <van-image
                width="2rem"
                height="2rem"
                fit="cover"
                :src="item.photoPathUri"
              />
            </van-col>
            <van-col span="18">
              <div class="photoDescLabel">描述</div>
              <div class="photoDescText" style="white-space: pre-wrap;">{{ item.photoContent }}</div>
            </van-col>
          </van-row>
          <van-row style="margin-top: 10px;">
            <div class="photoDescLabel"> {{ item.projectNo }} {{ item.major }} </div>
          </van-row>
          <van-row>
            <div class="canReceive" :class="{ isGrayTextisBlueText: true }">
              {{ item.registerTime }}
              <van-button v-if="showDel"
                type="info"
                class="darkEqWidthBtn"
                size="small"
                @click.stop="goDel(item.recNo)"
                >删除</van-button
              >
            </div>
          </van-row>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import common from "../../utils/common";
import { Notify } from "vant";
import { photoList, deletePhoto } from "@/api/photo";

export default {
  name: "photoList",
  data() {
    return {
      photoType: "",
      title: "",
      loading: false,
      finished: false,
      isRefreshLoading: false,
      error: false,
      page: 0,
      limit: 10,
      dataList: [],
      showAdd: false,
      showDel: false,
    };
  },
  mounted() {
    this.project = common.getProject();
    if (
      this.project == null ||
      this.project == undefined ||
      !this.project.workNo
    ) {
      Notify({ type: "danger", message: "获取工作控制号失败" });
    }
    this.photoType = this.$route.query.photoType;
    if (
      this.photoType == null ||
      this.photoType == "" ||
      this.photoType == "undefined"
    ) {
      this.photoType = common.getItem("photoType");
    } else {
      common.setItem("photoType", this.photoType);
    }
    if (this.photoType == "1") {
      this.title = "质量照片";
    } else if (this.photoType == "2") {
      this.title = "进度照片";
    } else {
      Notify({ type: "danger", message: "参数错误：未设置照片类型" });
    }
    if (common.hasPermision("qualityProgressPhoto:add:" + this.photoType)) {
      this.showAdd = true;
    } else {
      this.showAdd = false;
    }
    if (common.hasPermision("qualityProgressPhoto:delete:" + this.photoType)) {
      this.showDel = true;
    } else {
      this.showDel = false;
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "workbench",
      });
    },
    toUpload() {
      if (!common.hasPermision("qualityProgressPhoto:add:" + this.photoType)) {
					Notify({ type: 'danger', message: "无操作权限" });
					return;
				}
      this.$router.push({
        name: "photoUpload",
        query: { categoryType: this.categoryType },
      });
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.page = 1;
      this.dataList = [];
      this.onLoad();
    },
    loadMore() {
      this.page += 1; //页数+1
      this.onLoad();
    },
    onLoad() {
      let data = {
        page: this.page,
        limit: this.limit,
        workNo: this.project.workNo,
        photoType: this.photoType,
      };
      if (this.isRefreshLoading) {
        data.page = 1;
        this.dataList = [];
        this.isRefreshLoading = false;
      }
      photoList(data).then((response) => {
        this.loading = false;
        if (response.data.resultCode === 200) {
          this.dataList = this.dataList.concat(response.data.body.records);
          if (response.data.body.records.length === 0) {
            this.finished = true;
          }
        } else {
          this.finished = true;
        }
      });
    },
    goDel(id) {
      if (!common.hasPermision("qualityProgressPhoto:delete:" + this.photoType)) {
					Notify({ type: 'danger', message: "无操作权限" });
					return;
			}
      this.$confirm({
        title: "提示",
        message: "确认删除此记录吗？",
        btn: {
          okText: "确定",
          cancelText: "取消",
        },
      })
        .then(() => {
          deletePhoto(id).then((response) => {
            if (response.data.messageCode == "SUCCESS") {
              Notify({ type: "success", message: "操作成功" });
			  this.onRefresh();
            } else {
              Notify({ type: "danger", message: response.data.resultMessage });
            }
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>
